import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SingleTableModel } from '../models/singleTableModel';
import { ExcelJson } from '../models/excelData';
import { ApiClientsService } from '../services/apiClients.service';
import { AuthService } from '../services/auth.service';
import { ExportService } from '../services/export.service';
import { ErrorService } from '../services/error.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-apiClients',
  templateUrl: './apiClients.component.html',
  styleUrls: ['./apiClients.component.css'],
  standalone: false
})
export class ApiClientsComponent implements OnInit {
  newClient = new SingleTableModel('', 'api-client', '', '', true, 'api-client', '', '', '', '', '', 0, '', '', 'tenant', localStorage.getItem('UserName') ?? '','');
  searchClient = new SingleTableModel('', 'api-client', '', '', true, 'api-client', '', '', '', '', '', 0, '', '', '', localStorage.getItem('UserName') ?? '', '');
  clients: SingleTableModel[] = [];
  filteredClients: SingleTableModel[] = [];
  action: string = 'view';
  p: number = 1;
  errorMessage: string = '';
  isAdminClient: boolean = false;
  isTenantClient: boolean = false;
  isMerchantClient: boolean = false;
  isLoading: boolean = true;
  @ViewChild('clientDetails') clientDetails!: ElementRef;
  fileName: string = '';

  constructor(private clientsService: ApiClientsService, private authService: AuthService, private exportService: ExportService, private errorService: ErrorService, private datePipe: DatePipe) {

  }
  ngOnInit(): void {
    this.isAdminClient = this.authService.IsAdminUser$.value;
    this.isTenantClient = this.authService.IsTenantUser$.value;
    this.isMerchantClient = this.authService.IsMerchantUser$.value;

    if (this.isAdminClient) {
      this.getAllClients();
    }
    else {
      this.getClientsForUser();
    }
  }

  updateAction(action: string) {
    this.action = action;
  }

  searchClients() {
    if (this.clients.length > 0) {
      this.filteredClients = [];

      this.filteredClients.push(...this.clients.filter((x) =>
        (x.name?.toLowerCase().includes(this.searchClient.name?.toLowerCase()) || this.searchClient.name == '')
        && (x.id?.toLowerCase().includes(this.searchClient.id?.toLowerCase()) || this.searchClient.id == '')
      ));
      this.p = 1;
    }
  }

  getAllClients1() {
    this.clientsService.getAllClientsWithLimit(localStorage.getItem('accessKey') ?? '', 10, '', '').subscribe((data) => {
      this.clients = data;
      this.filteredClients = data;
    }, (error) => {
      this.errorMessage = this.errorService.alertError(error);
    });
  }

  getAllClients() {
    this.clientsService.getAllClients().subscribe((clients) => {
      if (Object.keys(clients).length > 0) {
      if (clients.hasOwnProperty('message')) {
        this.errorMessage = clients.message;
      }
      else {
        if (clients.hasOwnProperty('Item')) {
          this.clients = [];
          this.filteredClients = [];
          this.clients.push(clients.Item);
          this.filteredClients.push(clients.Item);          
        }
        else {
          this.clients = clients.Items;
          this.filteredClients = clients.Items;
        }
        this.clients.forEach((a: SingleTableModel) => {
          let apiAssociations = a.accessAssociation.split(',');
          let apiIds: string[] = [];
          for (let i in apiAssociations) {
            if (a.clientType == 'tenant' || a.clientType == 'terminal')
              apiIds.push(apiAssociations[i].split('|')[0]);
            else if (a.clientType == 'merchant')
              apiIds.push(apiAssociations[i].split('|')[0] + '-' +apiAssociations[i].split('|')[1]);
          }
          a.accessAssociationIds = apiIds.join(',');
        });
        }
      }
      else {
        this.clients = [];
        this.filteredClients = [];
      }
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      this.errorMessage = this.errorService.alertError(error);
    });
  }

  getClientsForUser() {
    this.clientsService.getClientsForUser().subscribe((clients) => {
      if (Object.keys(clients).length > 0) {
        if (clients.hasOwnProperty('message')) {
          this.errorMessage = clients.message;
        }
        else {
          if (clients.hasOwnProperty('Item')) {
            this.clients = [];
            this.filteredClients = [];
            this.clients.push(clients.Item);
            this.filteredClients.push(clients.Item);
          }
          else {
            this.clients = clients;
            this.filteredClients = clients;
          }
          this.clients.forEach((a: SingleTableModel) => {
            let apiAssociations = a.accessAssociation.split(',');
            let apiIds: string[] = [];
            for (let i in apiAssociations) {
              if (a.clientType == 'tenant' || a.clientType == 'terminal')
                apiIds.push(apiAssociations[i].split('|')[0]);
              else if (a.clientType == 'merchant')
                apiIds.push(apiAssociations[i].split('|')[0] + '-' + apiAssociations[i].split('|')[1]);
            }
            a.accessAssociationIds = apiIds.join(',');
          });
        }
      }
      else {
        this.clients = [];
        this.filteredClients = [];
      }
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      this.errorMessage = this.errorService.alertError(error);
    });
  }

  onSubmit(updatedAction: string) {
  }

  refreshClients(value: string) {
    this.action = 'view';
    this.searchClient = new SingleTableModel('', '', '', '', true, 'api-client', '', '', '', '', '', 0, '', '', '', localStorage.getItem('UserName') ?? '','');
    this.resetNewClient();
    if (value == 'refresh') {
      //this.isLoading = false;
      if (this.isAdminClient) {
        this.getAllClients();
      }
      else {
        this.getClientsForUser();
      }
      this.updateAction('view');
    }
    else if (value == 'reload') {
      this.filteredClients = [];
      this.filteredClients.push(...this.clients);
      this.updateAction('view');
    }
    else if (value == 'startLoading') {
      this.isLoading = true;
    }
    else if (value == 'stopLoading') {
      this.isLoading = false;
    }
    else {
      this.action = 'update';
      this.newClient = JSON.parse(value);
    }
  }

  resetNewClient() {
    this.newClient.id = '';
    this.newClient.name = '';
    this.newClient.accessAssociation = '';
    //this.newClient.accessIds = '';
  }

  exportElmToExcel(): void {
    this.exportService.exportTableElmToExcel(this.clientDetails, 'client_details');
  }

  exportToCsv(): void {
    let exportRows: SingleTableModel[] = [];
    this.filteredClients.forEach(client => {
      exportRows.push(new SingleTableModel(client.id, client.transactionId, client.email, client.flow_id, client.isActive, client.recordType, client.accessKey, client.name, client.transactionJSON, client.tsn, this.datePipe.transform(new Date(client.updateDate), 'yyyy-MM-dd HH:mm:ss')!, client.updateEpochTime, client.apiKey, client.accessAssociationIds, client.clientType, client.updateBy, client.accessAssociationIds));
      });

    this.fileName = this.filteredClients.length > 1 ? 'Api_Client_Details_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss') : 'Api_Client_Details_' + this.filteredClients[0].id + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');

    this.exportService.exportToCsv(exportRows, this.fileName, ['id', 'name', 'accessKey', 'isActive', 'clientType' ,'apiKey', 'accessAssociation', 'updateBy', 'updateDate'],
      ['ApiClient Id', 'ApiClient Name', 'ApiClient AccessKey', 'Active', 'Client Type', 'API Key', 'Access Association', 'Modified By', 'Modified Date']);
  }

  exportToExcel(): void {
    const edata: Array<ExcelJson> = [];
    const udt: ExcelJson = {
      data: [
        //{ A: 'ApiClient Details' }, // title
        { A: 'ApiClient Id', B: 'ApiClient Name', C:'ApiClient AccessKey',D:'Active', E:'Client Type', F:'API Key', G:'Access Association', H:'Modified By', I: 'Modified Date' }, // table header
      ],
      skipHeader: true
    };
    udt.data.push(this.filteredClients);
    this.filteredClients.forEach(client => {
      udt.data.push({
        A: client.id,
        B: client.name,
        C: client.accessKey,
        D: client.isActive,
        E: client.clientType,
        F: client.apiKey,
        G: client.accessAssociationIds,
        H: client.updateBy,
        I: this.datePipe.transform(new Date(client.updateDate), 'yyyy-MM-dd HH:mm:ss')
      });
    });
    edata.push(udt);
    this.fileName = this.filteredClients.length > 1 ? 'Api_Client_Details_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss') : 'Api_Client_Details_' + this.filteredClients[0].id + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');
    this.exportService.exportJsonToExcel(edata, this.fileName);
  }


}
